<div class="separator text-secondary gap-4">{{ i18nScope + '.common.or' | transloco }}</div>
